import React from 'react'
import './home_uno.css'
import puntos from '../../../assets/imgs/home_uno/puntos.png'
import puntos_XL from '../../../assets/imgs/home_uno/puntos_XL.png'
import fotoRS from '../../../assets/imgs/home_uno/fotoRSP.png'
import fotoRS_Movil from '../../../assets/imgs/home_uno/fotoRS_Movil.png'
import { useTranslation } from 'react-i18next'


const Home_uno = () => {

    const [t] = useTranslation("home");

    const handleMouseEnter = (idx) =>  {
        const elemento = document.getElementById("hvr_"+ idx);
        if(idx === 1 || idx === 4 || idx === 6 || idx === 9 ){
            elemento.style.transform = "translateX(" + (-50) + "px)";
            elemento.style.transition = "1s";
        }else{
            elemento.style.transform = "translateX(" + (50) + "px)";
            elemento.style.transition = "1s";
        }
    } 

    const handleMouseLeave = (idx) =>  {
        const elemento = document.getElementById("hvr_"+ idx);
        elemento.style.transform = "translateX(" + (10) + "px)";
        elemento.style.transition = "1s";
    } 

    return (
        <div className="home_uno">
            
            <div className="puntos_1div">
                <img className="puntos_1" src={puntos}/>
            </div>
            <div className="hero">
                <ul className="hero_bg1">
                    <li className="textstyle_1 " id="hvr_1">{(t('header.leadership'))}</li>
                    <li className="textstyle_2 " id="hvr_2">{(t('header.freedom'))}</li>
                    <li className="textstyle_1 " id="hvr_3">{(t('header.entrepreneurship'))}</li>
                </ul>
                <ul className="hero_bg2">
                    <li className="textstyle_2" id="hvr_4">{(t('header.education'))}</li>
                    <li className="textstyle_1" id="hvr_5">{(t('header.inclusive-prosperity'))}</li>
                </ul>
                <ul className="hero_bg3">
                    <li className="textstyle_1 " id="hvr_6">{(t('header.rule-of-law'))}</li>
                    <li className="textstyle_2" id="hvr_7">{(t('header.art-and-culture'))}</li>
                    <li className="textstyle_1 " id="hvr_8">{(t('header.innovation'))}</li>
                </ul>
                <ul className="hero_bg4">
                    <li className="textstyle_2" id="hvr_9">{(t('header.environment'))}</li>
                    <li className="textstyle_2" id="hvr_10">{(t('header.wellness'))}</li>
                </ul>
            </div>
            <div className="puntos_2div">
                <img className="puntos_2" src={puntos}/>
            </div>
            <div className="puntos_XLdiv">
                <img className="puntos_XL" src={puntos_XL}/>
            </div>
            <div className="fotoRS_div">
                <img src={fotoRS} className="fotoRS" />
            </div>
            <div className="fotoRS_div_movil">
                <img src="/assets/img/fotoRS_Movil.png" className="fotoRS_movil" />
            </div>
            
            <div className="hero_hidden">
                <ul className="hero_bg1">
                    <li className="textstyle_1 " onMouseLeave={() => handleMouseLeave(1)} onMouseEnter={() => handleMouseEnter(1)}>Liderazgo</li>
                    <li className="textstyle_2 " onMouseLeave={() => handleMouseLeave(2)} onMouseEnter={() => handleMouseEnter(2)}>Libertad</li>
                    <li className="textstyle_1 " onMouseLeave={() => handleMouseLeave(3)} onMouseEnter={() => handleMouseEnter(3)}>Emprendimiento</li>
                </ul>
                <ul className="hero_bg2">
                    <li className="textstyle_2 " onMouseLeave={() => handleMouseLeave(4)} onMouseEnter={() => handleMouseEnter(4)}>Educacion</li>
                    <li className="textstyle_1 " onMouseLeave={() => handleMouseLeave(5)} onMouseEnter={() => handleMouseEnter(5)}>Prosperidad Incluyente</li>
                </ul>
                <ul className="hero_bg3">
                    <li className="textstyle_1 " onMouseLeave={() => handleMouseLeave(6)} onMouseEnter={() => handleMouseEnter(6)}>Estado de Derecho</li>
                    <li className="textstyle_2 " onMouseLeave={() => handleMouseLeave(7)} onMouseEnter={() => handleMouseEnter(7)}>Arte & cultura</li>
                    <li className="textstyle_1 " onMouseLeave={() => handleMouseLeave(8)} onMouseEnter={() => handleMouseEnter(8)}>Innovacion</li>
                </ul>
                <ul className="hero_bg4">
                    <li className="textstyle_2 " onMouseLeave={() => handleMouseLeave(9)} onMouseEnter={() => handleMouseEnter(9)}>Educacion</li>
                    <li className="textstyle_1 " onMouseLeave={() => handleMouseLeave(10)} onMouseEnter={() => handleMouseEnter(10)}>Medio Ambiente</li>
                </ul>
            </div>
        </div>
    )
}

export default Home_uno
